import { queryLatestData } from '@/api/stateData'

const realTimeData = {
  state: {
    stateData: []
  },

  mutations: {
    SET_STATE_DATA: (state, data) => {
      state.stateData = data
    }
  },

  actions: {
    //
    async queryLatestStateData({ commit }, params) {
      const response = await queryLatestData(params)
      // return response.data
      console.log(response.data)
      // commit('SET_BMAP_INFOS', response.data)
      if (response.data != null) {
        commit('SET_STATE_DATA', response.data)
      }
    }
  }
}

export default realTimeData
